/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit, inject, ChangeDetectorRef } from '@angular/core';
import { RightPanelService } from '@services/right-panel.service';
import { SelectMeasurementComponent } from '../../components/select-measurement/select-measurement.component';
import { RightPanelMenuOption } from 'app/components/right-panel/right-panel.component';
import { TranslateService } from '@ngx-translate/core';
import { MeasurementSelectionService } from '../../services/measurement-selection.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { distinctUntilChanged } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { MeasurementsRouteId } from '../../measurement.routes';
import { ApiClientService } from '@services/api-client';
import { MeasurementDataService } from '../../services/measurement-data.service';
import { ControlSettings } from '../../components/control-panel/control-panel.component';
import { MeasurementData } from '../../models/measurement-view.types';
@UntilDestroy()
@Component({
    selector: 'app-measurement-view',
    standalone: false,
    templateUrl: './measurement-view.component.html',
    styleUrls: ['./measurement-view.component.scss']
})
export class MeasurementViewComponent implements OnInit {
    private readonly rightPanelService = inject(RightPanelService);
    private readonly translateService = inject(TranslateService);
    private readonly measurementSelectionService = inject(MeasurementSelectionService);
    private readonly changeDetectorRef = inject(ChangeDetectorRef);
    private readonly route = inject(ActivatedRoute);
    private readonly apiClientService = inject(ApiClientService);
    private readonly measurementDataService = inject(MeasurementDataService);

    public selectedMeasurementId: string | null = null;
    public measurementData: MeasurementData | null = null;
    public controlSettings: ControlSettings = {
        selectionMode: 'hover',
        amplitudeSize: 'medium',
        timeFormat: 'absolute'
    };
    public loading = false;

    public ngOnInit(): void {
        this.selectedMeasurementId = this.route.snapshot.paramMap.get(MeasurementsRouteId.MeasurementId);
        this.openMeasurementList();

        this.measurementSelectionService.selectedMeasurementId$
            .pipe(untilDestroyed(this), distinctUntilChanged())
            .subscribe((measurementId) => {
                if (measurementId) {
                    this.selectedMeasurementId = measurementId;
                    this.measurementSelectionService.setLoading(true);
                    this.fetchData();
                }
                this.changeDetectorRef.markForCheck();
            });
    }

    private fetchData(): void {
        this.loading = true;
        this.apiClientService.getMeasurementFinalResult$(this.selectedMeasurementId).subscribe({
            next: (data: MeasurementData) => {
                this.measurementData = data;
                this.measurementDataService.loadMeasurementData(this.measurementData);
                this.loading = false;
                this.measurementSelectionService.setLoading(false);
                this.changeDetectorRef.markForCheck();
            },
            error: (error) => {
                console.error('Failed to fetch measurement data:', error);
                this.loading = false;
                this.measurementSelectionService.setLoading(false);
                this.changeDetectorRef.markForCheck();
            }
        });
    }

    private openMeasurementList(startCollapsed: boolean = true): void {
        this.measurementSelectionService.selectMeasurement(this.selectedMeasurementId);
        const options = this.getMenuOptions();
        this.rightPanelService.showComponentWithMenu(
            this.translateService.instant('FEATURES.MEASUREMENTS.TITLE_VIEW') as string,
            SelectMeasurementComponent,
            {
                selectedMeasurementId: this.selectedMeasurementId
            },
            options,
            true,
            true,
            true,
            'assessment',
            startCollapsed
        );
    }

    private getMenuOptions(): RightPanelMenuOption[] {
        return [
            {
                icon: 'assessment',
                name: 'Measurements',
                action: () => this.showMeasurementsPanel(),
                disabled: false
            }
        ];
    }

    private showMeasurementsPanel(): void {
        this.rightPanelService.setCollapsed(false);
    }

    public onSettingsChanged(settings: ControlSettings): void {
        this.controlSettings = settings;
        this.changeDetectorRef.markForCheck();
    }
}
